import * as yup from "yup";

const insertSchema = (translate: Function) => yup.object().shape({
	efa024Ip: yup.string().required(translate("Endereço IP é necessário"))
});

export default insertSchema;
